// LAP-551 — Traduction des modèles DataGrid (tri, filtres) en paramètres d'URL
// pour les listes paginées côté serveur. Le backend (Investments/views.py,
// getMarketDetailPage) attend :
//   ordering=<champ> ou -<champ>
//   filters={"link":"and","items":[{"field":"price","op":">","value":10}]}

/** sortModel MUI -> paramètre `ordering` Django (« -price » = décroissant). */
export const buildOrdering = (sortModel) => {
  if (!Array.isArray(sortModel) || sortModel.length === 0) return ''
  const { field, sort } = sortModel[0]
  if (!field || !sort) return ''
  return sort === 'desc' ? `-${field}` : field
}

const VALUELESS_OPERATORS = ['isEmpty', 'isNotEmpty']

/** filterModel MUI -> paramètre `filters` (JSON). Chaîne vide si rien à filtrer. */
export const buildFilters = (filterModel) => {
  const items = (filterModel?.items || [])
    .filter((i) => {
      if (!i.columnField || !i.operatorValue) return false
      if (VALUELESS_OPERATORS.includes(i.operatorValue)) return true
      if (Array.isArray(i.value)) return i.value.length > 0
      return i.value !== undefined && i.value !== null && i.value !== ''
    })
    .map((i) => ({ field: i.columnField, op: i.operatorValue, value: i.value }))
  if (items.length === 0) return ''
  return JSON.stringify({ link: filterModel?.linkOperator || 'and', items })
}
